module.exports = __webpack_public_path__ + "static/media/features_img.313315d7.svg";